import {
  Component,
  Input,
  AfterViewInit,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import QRCodeStyling from 'qr-code-styling';

@Component({
  selector: 'app-qr-code',
  template: `<div #qrContainer style="margin-bottom: -6px;"></div>`,
  styles: [],
})
export class QrCodeComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() data: string = '';
  @Input() logoUrl: string = '/assets/img/Logo-TIX-F_negro.png';
  @Input() size: number = 150;
  @Output() qrReady = new EventEmitter<void>();

  @ViewChild('qrContainer') qrContainer!: ElementRef;

  private qrCode!: QRCodeStyling;
  private isReady = false;
  private imageLoadTimeout: any;

  ngAfterViewInit(): void {
    this.initializeQRCode();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.qrCode && this.qrContainer) {
      const shouldReinitialize =
        (changes['data'] && !changes['data'].firstChange) ||
        (changes['logoUrl'] && !changes['logoUrl'].firstChange) ||
        (changes['size'] && !changes['size'].firstChange);

      if (shouldReinitialize) {
        this.isReady = false;
        if (this.qrContainer.nativeElement) {
          this.qrContainer.nativeElement.innerHTML = '';
        }
        this.initializeQRCode();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.imageLoadTimeout) {
      clearTimeout(this.imageLoadTimeout);
    }
  }

  private initializeQRCode(): void {
    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = () => {
      const base64Image = this.imageToBase64(img);
      this.createQRCode(base64Image);
    };

    img.onerror = () => {
      console.warn('Error cargando logo del QR, creando QR sin logo');
      this.createQRCode(undefined);
    };

    img.src = this.logoUrl;

    this.imageLoadTimeout = setTimeout(() => {
      if (!this.isReady) {
        console.warn('Timeout cargando logo, creando QR de todas formas');
        if (!this.isReady) this.createQRCode(undefined);
      }
    }, 2000);
  }

  private imageToBase64(img: HTMLImageElement): string {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.drawImage(img, 0, 0);
      try {
        return canvas.toDataURL('image/png');
      } catch (e) {
        console.warn(
          'No se pudo convertir imagen a base64 (posible CORS), usando URL original'
        );
        return this.logoUrl;
      }
    }
    return this.logoUrl;
  }

  private createQRCode(imageSource?: string): void {
    const finalImage = imageSource || this.logoUrl;

    this.qrCode = new QRCodeStyling({
      width: this.size,
      height: this.size,
      data: this.data,
      image: 'https://tix-shared.s3.us-east-1.amazonaws.com/logo-tix.png',
      type: 'canvas',
      dotsOptions: {
        color: '#000000',
        type: 'rounded',
      },
      backgroundOptions: {
        color: '#ffffff',
      },
      imageOptions: {
        crossOrigin: 'anonymous',
        margin: 20,
      },

      cornersSquareOptions: {
        type: 'extra-rounded',
      },
    });

    if (this.qrContainer && this.qrContainer.nativeElement) {
      this.qrContainer.nativeElement.innerHTML = '';
      this.qrCode.append(this.qrContainer.nativeElement);

      setTimeout(() => {
        this.isReady = true;
        this.qrReady.emit();
      }, 50);
    }
  }

  public get ready(): boolean {
    return this.isReady;
  }
}
